// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3T9tt","content":"Consent_content__ETbTV","footer":"Consent_footer__3tA7G"};